import {base} from './basicLayout';
import {CART_ITEM_TYPE} from '../../common/constants/constants';
import {mapActions} from 'vuex';
import {restPrefixV2} from '../../common/api/urls';
import ChannelsLinkOrModal from '../../modules/WSPP01-product-package/WSPP01-accordion/channels-link-or-modal.vue';
import detailsModal from '../../common/modal/modal';
import eventBus from '../../common/event-bus/event-bus';
import fullPageLoader from '../../common/loader/loader.vue';
import modalStore from '../../common/modal/modal.vuex';
import set01Settlement from '../../modules/SET01-settlement/SET01-settlement.js';
import Vue from 'vue';
import wspdsc01ProductDescription from '../../modules/WSPDSC01-product-description/WSPDSC01-product-description.vue';
import wspdt01ProductDetails from '../../modules/WSPDT01-product-details/WSPDT01-product-details.vue';
import wspp01Accordion from '../../modules/WSPP01-product-package/WSPP01-accordion/WSPP01-accordion.vue';

document.body.addEventListener('jsLoaded', function () {
	base.store.registerModule('productDetailsStore', modalStore);

	Vue.component('channels-link-or-modal', ChannelsLinkOrModal);

	(() => new Vue({
		el: '#vue-app',
		components: {
			fullPageLoader,
			modal: detailsModal,
			set01Settlement,
			wspdsc01ProductDescription,
			wspdt01ProductDetails,
			wspp01Accordion
		},
		extends: base,
		data() {
			return {
				webitem: null,
				items: [],
				id: null,
				showError: false
			};
		},
		computed: {
			containsMultipleItem() {
				return this.items.length > 1;
			},

			services() {
				return this.items.filter(item => item.type != CART_ITEM_TYPE.PRODUCT);
			},

			products() {
				return this.items.filter(item => item.type == CART_ITEM_TYPE.PRODUCT);
			}
		},
		created() {
			eventBus.$on('on-current-address-changed', address => {
				if (address) this.getWebItem();
			});

			const searchParams = new URLSearchParams(window.location.search);
			this.id = searchParams.get('id');
			this.getWebItem();
		},
		methods: {
			getWebItem() {
				window.axios.get(`${restPrefixV2}/webshop/web-item-end-page/${this.id}`).then(response => {
					this.webitem = response.data.webitem;
					this.items = response.data.items;
					this.showError = false;
				}).catch(err => {
					const errorCode = err.response && err.response.data ? err.response.data.errorCode : false;
					if (errorCode == 'wrong_address') this.showError = true;
				});
			}
		}
	}))();
});



// WEBPACK FOOTER //
// ../source/build-entry/layouts/wsprd.js